import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import AdminPanel from './AdminPanel.js';
import reportWebVitals from './reportWebVitals.js';

// Hidden admin dashboard at /#admin — no server routing needed.
const isAdmin = window.location.hash === '#admin';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>{isAdmin ? <AdminPanel /> : <App />}</React.StrictMode>
);

reportWebVitals();
